function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/agency.css";
import * as Listing from "./components/listing";
import { MAP_TILER_APIKEY, MAP_TILER_VALUATION_ZOOM_AGENCY_DETAILS, MAP_TILER_STYLE } from "./components/variables";
import axios from "axios";
// @ts-ignore
import FiltersRealEstateInAgency from "@vueEntry/FiltersRealEstateInAgency.vue";
// @ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
// @ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
// @ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useModals } from "@wkComposables/useModals";
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useFavourite } from "@wkComposables/useFavourite";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import SwiperSlide from "@vueEntry/SwiperCarousel/SwiperSlide.vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
import { createApp, defineAsyncComponent } from "vue";
import { mapActions, mapState, createPinia } from "pinia";
import { useBaseStore, useSearchBeanStore, useLoggedUserStore, usePublicUserMenuStore, useModalStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import { transformReImages } from "@utils/ImageUtils";
//@ts-ignore
import { IMAGE_FORMATS as _IMAGE_FORMATS } from "@customTypes/ImageFormatsEnum";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import { MailIcon } from "@vueEntry/SvgIcons/MailIcon";
//@ts-ignore
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
//@ts-ignore
import { redirectToApp } from "@utils/AppRedirectUtils";
var loadImage = function loadImage(src) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.onload = function () {
      resolve(src);
    };
    image.onerror = function () {
      reject(src);
    };
    image.src = src;
  });
};
var agencyBox = {
  data: {
    heightParagraph: 0,
    heightContainer: 0,
    hideButton: true
  },
  onMounted: function onMounted(vueInstance) {
    var _a, _b, _c, _d;
    // @ts-ignore
    vueInstance.heightContainer = (_b = (_a = vueInstance.$refs.agencyDescriptionContainer) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    // @ts-ignore
    vueInstance.heightParagraph = (_d = (_c = vueInstance.$refs.agencyDescriptionParagraph) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0;
    // @ts-ignore
    if (vueInstance.heightParagraph > vueInstance.heightContainer) {
      // @ts-ignore
      vueInstance.hideButton = false;
    }
  }
};
var filterModalContentAgency = {
  components: {
    FiltersRealEstateInAgency: FiltersRealEstateInAgency
    // Modal
  },
  data: {
    isClosed: false,
    openModal: false,
    isMobile: false
  },
  onMounted: function onMounted(vueInstance) {
    if (window.screen.width < BREAKPOINT.SMALL) {
      //@ts-ignore
      vueInstance.isMobile = true;
    }
  },
  methods: {
    transformReImages: transformReImages,
    handleBreadcrumbLinkClick: handleBreadcrumbLinkClick,
    handleInsertionClick: handleInsertionClick,
    useApp: function useApp() {
      redirectToApp("Dettaglio agenzia - Banner");
    },
    search: function search(e) {
      // @ts-ignore
      this.$refs.FiltersRealEstateInAgency.search(e);
    },
    reset: function reset() {
      // @ts-ignore
      this.$refs.FiltersRealEstateInAgency.resetFilter();
    },
    closeModal: function closeModal() {
      // @ts-ignore
      this.$refs.modalFilterAgency.closeModal();
    }
  }
};
var agencyContainer = {
  data: {
    agentsList: [],
    start: 0,
    leftOffset: 0
  },
  methods: function methods(vueInstance) {
    return {
      getAgent: function getAgent() {
        return axios.get("/rest/agency/getPublicAgentsData/".concat(window["_agencyID"], "/").concat(vueInstance.start, "/0")).then(function (response) {
          return response.data;
        });
      }
    };
  },
  onMounted: function onMounted(vueInstance) {
    axios.get("/rest/agency/getPublicAgentsData/".concat(window["_agencyID"], "/").concat(vueInstance.start, "/0")).then(function (response) {
      return response.data;
    }).then(function (agents) {
      vueInstance.agentsList = agents.value;
      // to remove the splide arrow if only one agent is present
      if (agents.key <= 1) vueInstance.options.classes.arrows = "d-none";
    });
  }
};
var agencyApp = createApp({
  name: "AgencyDetails",
  components: Object.assign(Object.assign(Object.assign(Object.assign({
    BaseButton: BaseButton,
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(function () {
      return import("@vueEntry/SwiperCarousel.vue");
    }),
    SwiperSlide: SwiperSlide,
    AccessibleSelect: AccessibleSelect,
    BaseIcon: BaseIcon,
    PublicUserMenu: PublicUserMenu,
    BaseBadge: BaseBadge,
    IntersectionObserverVue: IntersectionObserverVue,
    IntersectionObservableVue: IntersectionObservableVue,
    PhoneIcon: PhoneIcon,
    MailIcon: MailIcon,
    //@ts-ignore
    "share-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/ShareModal.vue");
    }),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/ContactAgencyModal.vue");
    }),
    //@ts-ignore
    "filters-re-agency-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/FiltersRealEstateInAgencyModal.vue");
    }),
    //@ts-ignore
    "orders-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/OrderModal.vue");
    }),
    //@ts-ignore
    "agency-details-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/AgencyDetailsModal.vue");
    }),
    //@ts-ignore
    "badge-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/BadgeModal.vue");
    })
  }, filterModalContentAgency.components), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }), LanguageIcons), CommonModals),
  setup: function setup() {
    var _useShowPhone = useShowPhone(),
      displayPhone = _useShowPhone.displayPhone,
      phoneLabel = _useShowPhone.phoneLabel,
      showPhone = _useShowPhone.showPhone;
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useFavourite = useFavourite(),
      handleAddFavorite = _useFavourite.handleAddFavorite,
      handleRemoveFavorite = _useFavourite.handleRemoveFavorite;
    var _useContactAgencyModa = useContactAgencyModal(),
      agencyModalData = _useContactAgencyModa.agencyModalData,
      reopenAfterLogin = _useContactAgencyModa.reopenAfterLogin,
      successModalDataEmitted = _useContactAgencyModa.successModalDataEmitted,
      amdLabels = _useContactAgencyModa.amdLabels,
      amdIcons = _useContactAgencyModa.amdIcons,
      listingType = _useContactAgencyModa.listingType,
      openContactModal = _useContactAgencyModa.openContactModal,
      openAndReturnToCAMS = _useContactAgencyModa.openAndReturnToCAMS;
    var _useModals = useModals(),
      setShowModal = _useModals.setShowModal,
      openAndReturnTo = _useModals.openAndReturnTo;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    var _useSearch = useSearch(),
      search = _useSearch.search,
      setOrderAndSearch = _useSearch.setOrderAndSearch,
      setOrderAndSearchInAgency = _useSearch.setOrderAndSearchInAgency;
    var _useShareModal = useShareModal(),
      shareModalData = _useShareModal.shareModalData,
      openShareModal = _useShareModal.openShareModal,
      gaEvent = _useShareModal.gaEvent;
    var _useBreakpoints = useBreakpoints(),
      isLarge = _useBreakpoints.isLarge;
    var _useUtilities = useUtilities(),
      redirectTo = _useUtilities.redirectTo;
    return {
      isLarge: isLarge,
      displayPhone: displayPhone,
      phoneLabel: phoneLabel,
      showPhone: showPhone,
      isAppBannerVisible: isAppBannerVisible,
      setShowModal: setShowModal,
      openAndReturnTo: openAndReturnTo,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData: agencyModalData,
      reopenAfterLogin: reopenAfterLogin,
      successModalDataEmitted: successModalDataEmitted,
      //CAM computed
      amdLabels: amdLabels,
      amdIcons: amdIcons,
      listingType: listingType,
      //CAM methods
      openContactModal: openContactModal,
      openAndReturnToCAMS: openAndReturnToCAMS,
      //Favourites methods
      handleAddFavorite: handleAddFavorite,
      handleRemoveFavorite: handleRemoveFavorite,
      //useFirebaseMessaging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick,
      //useSearch
      search: search,
      setOrderAndSearch: setOrderAndSearch,
      setOrderAndSearchInAgency: setOrderAndSearchInAgency,
      //useShareModal
      shareModalData: shareModalData,
      openShareModal: openShareModal,
      gaEvent: gaEvent,
      redirectTo: redirectTo
    };
  },
  data: function data() {
    return Object.assign(Object.assign(Object.assign({
      listMode: true
    }, agencyContainer.data), agencyBox.data), filterModalContentAgency.data);
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    IMAGE_FORMATS: function IMAGE_FORMATS() {
      return _IMAGE_FORMATS;
    },
    orderOptions: function orderOptions() {
      return window["orderOptions"];
    },
    orderSelected: function orderSelected() {
      var _this = this;
      return this.orderOptions.find(function (option) {
        return option.id === _this.searchBean.filterOrderId;
      }) || {
        id: 0
      };
    },
    staticMapImageUrl: function staticMapImageUrl() {
      // eslint-disable-next-line max-len
      return "https://api.maptiler.com/maps/".concat(MAP_TILER_STYLE, "/static/").concat(window["_longitude"], ",").concat(window["_latitude"], ",").concat(MAP_TILER_VALUATION_ZOOM_AGENCY_DETAILS, "/620x360@2x.png?key=").concat(MAP_TILER_APIKEY);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(useSearchBeanStore, ["searchBean"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  created: function created() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2 = this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.updateSearchBean(JSON.parse(window._serializedSearchBean));
            _context.next = 3;
            return this.initPublicUserMenu();
          case 3:
            if (!this.isMobile) {
              loadImage(this.staticMapImageUrl).then(function (url) {
                _this2.$refs.mapImage.style.backgroundImage = "url('".concat(url, "')");
              });
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
  },
  mounted: function mounted() {
    agencyContainer.onMounted(this);
    agencyBox.onMounted(this);
    filterModalContentAgency.onMounted(this);
    Listing.init({
      list: "#list-properties"
    });
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    goToDetail: function goToDetail(detailURL) {
      location.href = detailURL;
    },
    openFilterAgencyModal: function openFilterAgencyModal() {
      this.openModal = true;
    }
  }, agencyContainer.methods(this)), filterModalContentAgency.methods), mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useSearchBeanStore, ["updateSearchBean"])), {
    sendGAEvent: sendGAEvent,
    openBadgeModal: function openBadgeModal() {
      sendGAEvent("top_agency_widget_open_modal", {
        event_location: "agenzia-immobiliare"
      });
      this.setShowModal("BADGE_MODAL");
    }
  })
});
agencyApp.use(createPinia());
agencyApp.mount("#agency-details-main");
window["goToMarketingBadge"] = goToMarketingBadge;
export function goToMarketingBadge(baseUrl) {
  window.location.href = baseUrl + "?agency=" + window.location.pathname;
}